import type { SVGProps } from 'react'

export const CultureIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="22" height="22" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18.3334 9.50008C18.3334 14.1025 14.6025 17.8334 10.0001 17.8334M18.3334 9.50008C18.3334 4.89771 14.6025 1.16675 10.0001 1.16675M18.3334 9.50008H1.66675M10.0001 17.8334C5.39771 17.8334 1.66675 14.1025 1.66675 9.50008M10.0001 17.8334C7.86028 15.5866 6.66675 12.6028 6.66675 9.50008C6.66675 6.39737 7.86028 3.41354 10.0001 1.16675M10.0001 17.8334C12.1399 15.5866 13.3334 12.6028 13.3334 9.50008C13.3334 6.39737 12.1399 3.41354 10.0001 1.16675M1.66675 9.50008C1.66675 4.89771 5.39771 1.16675 10.0001 1.16675"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
